<template>
  <div>

    <v-row no-gutters
           class="text-body-1 align-center px-1"
           style="flex-wrap: nowrap; min-width: 300px;"
    >
    <v-col>
      <v-row no-gutters class="align-start">
        <event-icon v-model="eventType"></event-icon>
        <span style="font-size: 8pt; line-height: 10pt" class="font-weight-bold">{{value.legState}}</span>
      </v-row>
      <v-row no-gutters >
        <v-col class="text-body-2" v-if="time">
          <v-badge
              :color="diffColor"
              v-if="timeDiff !== 0"
              :content="timeDiffPrinted(timeDiff)"
          >
            {{ time | localMoment('HH:mm') }}
          </v-badge>
          <span v-else>{{ time | localMoment('HH:mm') }}</span>
        </v-col>
      </v-row>
    </v-col>
    <v-col>
      <v-row no-gutters class="d-flex align-center">
        <v-col cols="12" sm="6" class="text-h6">
          {{ value.flightNumber }}<span v-if="value.suffix" class="warning--text">{{ value.suffix }}</span>
        </v-col>
      </v-row>
      <v-row no-gutters class="d-flex align-center">
        <v-col cols="12" sm="6" class="text-body-2">{{ value.scheduledDepartureAirport }} - {{ value.actualArrivalAirport }}</v-col>
      </v-row>
      <v-row no-gutters class="d-flex align-center">
        <v-col cols="12" sm="6" class="text-body-2"><v-icon small color="secondary">mdi-airplane</v-icon>{{ value.acReg }}</v-col>
      </v-row>
    </v-col>
      <v-col>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" sm="6" class="text-h6">
            C{{ value.paxC }} Y{{ value.paxY }}
          </v-col>
        </v-row>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" sm="6" class="text-body-2"><v-icon small color="info">mdi-bag-suitcase-outline</v-icon>
            {{ value.baggageCount }}
          </v-col>
        </v-row>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="6" sm="3" class="text-body-2"><v-icon small color="info">mdi-map-marker-outline</v-icon>
            <span class="text-caption text-sm-body-2">
                  <template v-if="stand">
                    {{ stand }}
                  </template>
                  <template v-else>
                    -
                  </template>
            </span>
          </v-col>
          <v-col cols="6" sm="3" class="text-body-2"><v-icon small color="info">mdi-import</v-icon>
            <span class="text-caption text-sm-body-2">
                  <template v-if="gate">
                    {{ gate }}
                  </template>
                  <template v-else>
                    -
                  </template>
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col style="align-self: start;">
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" sm="6" class="text-h6">
           {{ value.trTime }}
          </v-col>
          <v-col cols="12" sm="6" class="text-body-2" >
            <span :class="connectionStateToColor(value.status)">&nbsp;{{ statusText(value.status) }}&nbsp;</span>
          </v-col>
        </v-row>
        <v-row no-gutters class="d-flex align-center">
          <v-col cols="12" sm="6" class="text-body-2">{{ decisionText(value.decision) }}</v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="value.remark"
           no-gutters
           class="text-body-1 px-1"
           style="flex-wrap: nowrap; min-width: 300px; text-align: center;"
    >
      <v-col>
        <v-row no-gutters class="align-center">
          <v-col cols="12" sm="12" class="text-body-4 remark">{{ value.remark }}</v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EventIcon from '@/components/EventIcon'
import moment from 'moment'
import { eventTypes } from '../config/eventTypes'

export default {
  name: 'DepartureAndArrivalItem',
  components: { EventIcon },
  props: {
    value: {
      type: Object,
      required: true
    },
    eventType: {
      type: String,
      required: true,
    },
    now: {
      type: Date,
      required: true
    },
  },
  computed: {
    time() {
      return this.eventType === eventTypes.arrival ? this.value.arrivalAt : this.value.departureAt
    },
    timeDiff() {
      return this.eventType === eventTypes.arrival ? this.value.arrDiffMinutes : this.value.depDiffMinutes
    },
    diffColor() {
      return this.timeDiff < 5 ? 'secondary' : (this.timeDiff > 20 ? 'error' : 'warning')
    },
    stand() {
      return this.eventType === eventTypes.arrival ? this.value.arrivalStand : this.value.departureStand
    },
    gate() {
      return this.eventType === eventTypes.arrival ? this.value.arrivalGate : this.value.boardingGate
    },
    diff() {
      return  -moment.utc(this.time).diff(moment(this.now), 'minutes')
    }
  },
  methods: {
    timeDiffPrinted(diff) {
      return diff === 0 ? '' : diff > 0 ? '+' + diff : diff
    },
    connectionStateToColor (connectionState) {
      if (connectionState === 'OK') {
        return 'status-ok'
      } else if (connectionState === 'CRITICAL') {
        return 'status-critical'
      } else if (connectionState === 'NEGATIVE') {
        return 'status-negative'
      }
      return ''
    },
    statusText (status) {
      if (status === 'OK') {
        return 'OK'
      } else if (status === 'CRITICAL') {
        return 'CRIT'
      } else if (status === 'NEGATIVE') {
        return 'NEG'
      }
      return ''
    },
    decisionText (decision) {
      if (decision === 'FINAL') {
        return 'FINAL'
      }
      return ''
    }
  }
}
</script>

<style>
.notActualItem {
  opacity: 0.4;
}
.status-ok {
  color: white;
  background-color: limegreen;
}
.status-critical {
  color: black;
  background-color: yellow;
}
.status-negative {
  color: white;
  background-color: red;
}
.remark {
  font-weight: bold;
  color: darkorange;
}
</style>
